import request from './request'

/**
 * 获取视频播放页信息
 * @param courseId 课程ID
 * @param videoId 视频ID
 * @returns {AxiosPromise<any>}
 */
export function getVideoInfo(courseId, videoId) {
  const url = '/course_detail/videoplay'
  return request.get(url, {
    params: {
      video_id: videoId,
      course_id: courseId
    }
  })
}

/**
 * 获取视频评论内容
 * @param videoId
 */
export function getCommentList(courseId, videoId, page) {
  const url = '/course_detail/commentlist'
  return request.get(url, {
    params: {
      course_id: courseId,
      video_id: videoId,
      page: page
    }
  })
}

/**
 * 提交评论
 * @param content
 */
export function submitComment(content, courseId, videoId, pid, stars) {
  const url = '/user_behavior/comment'
  return request({
    method: 'get',
    url: url,
    params: {
      content: content,
      course_id: courseId,
      video_id: videoId,
      pid: pid,
      stars
    }
  })
}

/**
 * 记录视频播放时长
 * @param courseId
 * @param videoId
 * @param browseTime
 * @returns {AxiosPromise<any>}
 */
export function browseTimeLog(courseId, videoId, browseTime, duration) {
  const url = '/browse_time_log/log'
  return request.get(url, {
    params: {
      video_id: videoId,
      course_id: courseId,
      browse_time: browseTime,
      duration: duration
    }
  })
}

/**
 * 统计进入视频播放页面的来源和次数
 * @param courseId
 * @param videoId
 * @param pageId 页面ID
 * @returns {AxiosPromise<any>}
 */
export function browsePageLog(courseId, videoId, pageId) {
  const url = '/browse_time_log/video_detail_log'
  return request.get(url, {
    params: {
      video_id: videoId,
      course_id: courseId,
      referer: pageId
    }
  })
}

/**
 * 获取课程相关信息
 * @param {Number} courseId
 */
export function relatedCourse(courseId) {
  const url = '/course_detail/relationcourse'
  return request.get(url, {
    params: {
      course_id: courseId
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/play.js